import { useQuery } from "@tanstack/react-query";
import { api } from "../../lib/api";
import type { OfferRule, OfferRulePatch } from "../../lib/types";
import { useCampaignMutation } from "./useCampaignMutation";

export const useOfferRules = (campaignId: string | undefined) =>
	useQuery({
		queryKey: ["offer-rules", campaignId],
		queryFn: () => api.get<{ items: OfferRule[] }>(`/api/campaigns/${campaignId}/rules`),
		enabled: Boolean(campaignId),
	});

const useRuleMutation = <TVariables>(
	campaignId: string,
	run: (variables: TVariables) => Promise<unknown>,
) => useCampaignMutation(campaignId, [["offer-rules", campaignId]], run);

export const useCreateRule = (campaignId: string) =>
	useRuleMutation(campaignId, (patch: OfferRulePatch) =>
		api.post(`/api/campaigns/${campaignId}/rules`, patch),
	);

export const useUpdateRule = (campaignId: string) =>
	useRuleMutation(campaignId, ({ ruleId, ...patch }: { ruleId: string } & OfferRulePatch) =>
		api.put(`/api/campaigns/${campaignId}/rules/${ruleId}`, patch),
	);

export const useDeleteRule = (campaignId: string) =>
	useRuleMutation(campaignId, (ruleId: string) =>
		api.remove(`/api/campaigns/${campaignId}/rules/${ruleId}`),
	);
